import { ADD_USER_SUCCESS, DELETE_USER_SUCCESS, EDIT_USER_SUCCESS, SET_SYSTEMS_LIST, SET_USER_ROLES, SET_USERS_DATA } from "../actionTypes/users";

const setUsers = users => ({
  type: SET_USERS_DATA,
  payload: { users }
});

const addUserAction = user => ({
  type: ADD_USER_SUCCESS,
  payload: { user }
});

const editUserAction = user => ({
  type: EDIT_USER_SUCCESS,
  payload: { user }
});

const deleteUserAction = deletedUserId => ({
  type: DELETE_USER_SUCCESS,
  payload: { deletedUserId }
});

const setUserRoles = roles => ({
  type: SET_USER_ROLES,
  payload: { roles }
});

const setSystemsList = systems => ({
  type: SET_SYSTEMS_LIST,
  payload: { systems }
});

const UserActions = {
  setUsers,
  addUserAction,
  editUserAction,
  deleteUserAction,
  setUserRoles,
  setSystemsList
};

export default UserActions;
